module.exports = __webpack_public_path__ + "img/icon-scene-2.58835f3b.png";